import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { portalApi } from "@/lib/api";
import { DEFAULT_PAGE_SIZE } from "@/lib/constants";
import { useOrganizationStore } from "@/stores/organizationStore";

/** Finalized royalty statements for the selected payee. Portal mode only. */
export function usePortalRoyaltyStatements({
  page = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  ordering,
}: {
  page?: number;
  pageSize?: number;
  ordering?: string;
} = {}) {
  const payeeId = useOrganizationStore((s) => s.currentPayee?.id);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["portal", "royalty-statements", payeeId, page, pageSize, ordering ?? null],
    queryFn: () =>
      portalApi.getRoyaltyStatements({
        payees: payeeId,
        page,
        page_size: pageSize,
        ordering,
      }),
    enabled: !!payeeId,
    placeholderData: keepPreviousData,
  });

  return {
    statements: data?.results ?? [],
    count: data?.count ?? 0,
    isLoading,
    isError,
    refetch,
  };
}

export function usePortalRoyaltyStatementHtml(id: string | undefined) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["portal", "royalty-statement-html", id],
    queryFn: () => portalApi.getRoyaltyStatementHtml(id!),
    enabled: !!id,
  });

  return { html: data?.html ?? null, isLoading, isError };
}
